function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { ApplicationTypeId } from '../models/application-type-id';
import ContainerKey from '../models/container-key';
import ItemHistory from '../models/item-history';
import { ItemType } from '../models/item-type';
import Permissions from '../models/permissions';
import { ProjectGroupContainer } from '../models/project-group-container';
import { firstGroupBy, ProjectGroupBy, secondGroupBy } from '../models/project-grouping';
import { assert, assertRequired } from '../common/assert';
import ItemLock, { LockLevel, LockType } from '../models/item-lock';
import User from '../models/user';
import { LockPermissions } from '../models';
export function isVirtualFolder(key) {
  return key.type === ItemType.AppGroup || key.type === ItemType.YearGroup;
}
export var NO_GROUP = 'NO_GROUP';
function appOrNone(app) {
  return app && app !== ApplicationTypeId.NONE ? app : NO_GROUP;
}
export function getGroupId(grouping, project) {
  var _project$year;
  return grouping === ProjectGroupBy.App ? appOrNone(project.application) : grouping === ProjectGroupBy.Year ? (_project$year = project.year) !== null && _project$year !== void 0 ? _project$year : NO_GROUP : NO_GROUP;
}
export function nextGrouping(grouping) {
  return {
    groupBy: secondGroupBy[grouping.groupBy],
    groupId: grouping.subGroupId
  };
}
export function isGroup(groupBy) {
  return !!groupBy && groupBy !== ProjectGroupBy.None;
}
export function isVirtualGroup(grouping) {
  return isGroup(grouping === null || grouping === void 0 ? void 0 : grouping.groupBy) && (!(grouping !== null && grouping !== void 0 && grouping.groupId) || !grouping.subGroupId && hasSecondary(grouping.groupBy));
}
export function hasSecondary(groupBy) {
  var secondary = secondGroupBy[groupBy];
  return isGroup(secondary);
}
export function isInProjectGroup(item, group) {
  if (!isGroup(group.groupBy) || !group.groupId) {
    return true;
  }
  var groupBy = firstGroupBy[group.groupBy];
  var projectGroupId = getGroupId(groupBy, item);
  // The incoming grouping's ID may come in with the wrong type.
  var filterGroupId = groupBy === ProjectGroupBy.Year ? parseInt(group.groupId, 10) : group.groupId;
  if (projectGroupId !== filterGroupId) {
    return false;
  }
  return isInProjectGroup(item, nextGrouping(group));
}
export function groupByToItemType(group) {
  var primary = firstGroupBy[group];
  if (!isGroup(primary)) {
    throw new Error('Cannot resolve item type for ProjectGroupBy.None');
  }
  return primary === ProjectGroupBy.App ? ItemType.AppGroup : ItemType.YearGroup;
}
export function itemTypeToGroupBy(type) {
  return type === ItemType.AppGroup ? ProjectGroupBy.App : type === ItemType.YearGroup ? ProjectGroupBy.Year : ProjectGroupBy.None;
}
var idDelimiter = '>';
export function projectGroupKeyToContainer(key) {
  assert(key.type === ItemType.AppGroup || key.type === ItemType.YearGroup, 'Invalid item type for Project Group Container', true, key.type, key);
  var tuple = key.id.split(idDelimiter);
  assert(tuple.length === 2 || tuple.length === 3, 'Invalid project group key ID', true, key.id, key);
  var groupBy = itemTypeToGroupBy(key.type);
  var _tuple = _slicedToArray(tuple, 3),
    parentId = _tuple[0],
    firstGroupId = _tuple[1],
    secondGroupId = _tuple[2];
  var client = new ContainerKey(parentId, ItemType.Client);
  var groupId = secondGroupId || firstGroupId;
  var superGroupId = secondGroupId ? firstGroupId : undefined;
  var app = groupBy === ProjectGroupBy.App ? groupId : superGroupId;
  var yearString = groupBy === ProjectGroupBy.Year ? groupId : superGroupId;
  var year = yearString ? parseInt(yearString, 10) : undefined;
  return createProjectGroupContainer(client, key, groupBy, false, app, year);
}
export function extractClient(key) {
  var _key$id$split = key.id.split(idDelimiter),
    _key$id$split2 = _slicedToArray(_key$id$split, 1),
    id = _key$id$split2[0];
  return new ContainerKey(id, ItemType.Client);
}
export function keyToGrouping(key) {
  assert(key.type === ItemType.AppGroup || key.type === ItemType.YearGroup, 'Invalid item type for Project Group Container', true, key.type, key);
  var tuple = key.id.split(idDelimiter);
  assert(tuple.length === 2 || tuple.length === 3, 'Invalid project group key ID', true, key.id, key);
  var groupBy = itemTypeToGroupBy(key.type);
  var firstGroupId = tuple[1];
  var secondGroupId = tuple[2];
  if (groupBy === ProjectGroupBy.Year) {
    if (!secondGroupId) {
      return {
        groupBy: groupBy,
        groupId: parseInt(firstGroupId, 10)
      };
    }
    return {
      groupBy: ProjectGroupBy.AppThenYear,
      groupId: firstGroupId,
      subGroupId: parseInt(secondGroupId, 10)
    };
  }
  if (groupBy === ProjectGroupBy.App) {
    if (!secondGroupId) {
      return {
        groupBy: groupBy,
        groupId: firstGroupId
      };
    }
    return {
      groupBy: ProjectGroupBy.YearThenApp,
      groupId: parseInt(firstGroupId, 10),
      subGroupId: secondGroupId
    };
  }
}
export function groupingToContainer(groupBy, grouping, parent, locked) {
  assertRequired(grouping.groupId, 'group ID for ProjectGroupContainer', false, grouping);
  var id = createProjectGroupId(parent.id, grouping.groupId, grouping.subGroupId);
  var type = groupByToItemType(groupBy);
  var key = new ContainerKey(id, type);
  var primary = firstGroupBy[grouping.groupBy];
  var app = primary === ProjectGroupBy.App ? grouping.groupId : grouping.subGroupId;
  var year = primary === ProjectGroupBy.Year ? grouping.groupId : grouping.subGroupId;
  return createProjectGroupContainer(parent, key, grouping.groupBy, locked, app, year);
}
export function containerToGrouping(container) {
  var groupBy = container.groupByType;
  var groupId = getGroupId(firstGroupBy[groupBy], container);
  var subGroupId = getGroupId(secondGroupBy[groupBy], container);
  return {
    groupBy: groupBy,
    groupId: groupId === NO_GROUP ? undefined : groupId,
    subGroupId: subGroupId === NO_GROUP ? undefined : subGroupId
  };
}
export function groupingToKey(parent, grouping) {
  assertRequired(grouping.groupId, 'group ID for groupingToKey', false, grouping);
  var id = createProjectGroupId(parent.id, grouping.groupId, grouping.subGroupId);
  var groupBy = grouping.subGroupId && hasSecondary(grouping.groupBy) ? secondGroupBy[grouping.groupBy] : firstGroupBy[grouping.groupBy];
  var type = groupByToItemType(groupBy);
  return new ContainerKey(id, type);
}
export function createProjectGroupId(parentId, groupId, subGroupId) {
  var tuple = subGroupId ? [parentId, groupId, subGroupId] : [parentId, groupId];
  return tuple.join(idDelimiter);
}
export function stringToGroupId(groupIdString, groupBy) {
  if (groupIdString === NO_GROUP) {
    return undefined;
  }
  return groupBy === ProjectGroupBy.Year ? parseInt(groupIdString, 10) : groupBy === ProjectGroupBy.App ? groupIdString : undefined;
}

// eslint-disable-next-line max-params
function createProjectGroupContainer(parent, key, groupBy, locked, application, year) {
  if (!isGroup(groupBy)) {
    throw new Error('Cannot create virtual folder for ProjectGroupBy.None');
  }
  var args = {
    id: key.id,
    type: key.type,
    name: "".concat(key.type, " ").concat(key.id),
    parent: parent,
    history: ItemHistory.none,
    permissions: Permissions.none,
    isShared: false,
    customFields: new Map(),
    hasFolders: true,
    hasDocuments: false,
    isClientUploadFolder: false,
    isTemplate: false,
    year: year,
    application: application,
    groupByType: groupBy,
    lock: locked ? createDescendentLock() : undefined
  };
  return new ProjectGroupContainer(args);
}
function createDescendentLock() {
  return new ItemLock(LockType.None, LockLevel.Descendant, new LockPermissions(false,
  // Create
  true, true, false,
  // Delete
  false,
  // Move
  true, true, true), User.none, ItemHistory.noDate, new Map());
}
